import React from 'react'
import PropTypes from 'prop-types'
import { RangeSlider, RangeValueInput } from 'components'
import { parseToNumber } from 'utils/parseNumbers'
import styles from './ValueFilter.module.scss'

const ValueFilter = ({
  rangeSlider,
  rangeValueInputMin,
  rangeValueInputMax,
}) => {
  const [minValue, setMinValue] = React.useState(rangeValueInputMin.valueRange)
  const [maxValue, setMaxValue] = React.useState(rangeValueInputMax.valueRange)
  const [localRange, setLocalRange] = React.useState(rangeSlider.valueRange)

  const onlyNumbers = value => {
    return parseToNumber(value)
  }

  const handleLocalRange = localValue => {
    setLocalRange(localValue)
    setMinValue(localValue.min)
    setMaxValue(localValue.max)
  }

  React.useEffect(() => {
    setLocalRange(rangeSlider.valueRange)

    if (onlyNumbers(minValue) < rangeValueInputMin.min) {
      setMinValue(rangeValueInputMin.min)
    } else {
      setMinValue(rangeValueInputMin.valueRange)
    }

    if (onlyNumbers(maxValue) > rangeValueInputMax.max) {
      setMaxValue(rangeValueInputMax.max)
    } else {
      setMaxValue(rangeValueInputMax.valueRange)
    }
  }, [rangeValueInputMin.valueRange, rangeValueInputMax.valueRange]) // eslint-disable-line

  return (
    <div className={styles.container}>
      <div className={styles.inputs}>
        <RangeValueInput
          value={minValue}
          onChange={setMinValue}
          {...rangeValueInputMin}
        />
        <RangeValueInput
          value={maxValue}
          onChange={setMaxValue}
          {...rangeValueInputMax}
        />
      </div>
      <RangeSlider
        max={rangeSlider.max}
        min={rangeSlider.min}
        onChange={handleLocalRange}
        onChangeComplete={rangeSlider.onChange}
        step={rangeSlider.step}
        className={styles.rangeSlider}
        value={localRange}
      />
    </div>
  )
}

ValueFilter.propTypes = {
  rangeSlider: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    step: PropTypes.number,
    valueRange: PropTypes.shape({
      max: PropTypes.number.isRequired,
      min: PropTypes.number,
    }).isRequired,
  }).isRequired,
  rangeValueInputMin: PropTypes.shape({
    id: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    valueRange: PropTypes.number.isRequired,
    min: PropTypes.number,
  }).isRequired,
  rangeValueInputMax: PropTypes.shape({
    id: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    valueRange: PropTypes.number.isRequired,
    max: PropTypes.number,
  }).isRequired,
}

export default ValueFilter
